"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var StudentReportCardController = /** @class */ (function () {
    function StudentReportCardController(UsersModel, user, reportData, VueStoreFactory) {
        this.UsersModel = UsersModel;
        this.user = user;
        this.VueStoreFactory = VueStoreFactory;
        this.reportData = reportData;
        this.totalItems = reportData.reportcards.total;
        if (this.totalItems > 0) {
            this.reportcard = reportData.reportcards.data[0];
        }
        else {
            this.reportcard = null;
        }
        this.currentPage = 1;
    }
    StudentReportCardController.prototype.studentIsMinor = function () {
        var dob = this.VueStoreFactory.state.auth.usermeta.find(function (meta) { return meta.meta_key === "dob"; });
        return (0, time_1.isMinor)(dob.meta_value);
    };
    StudentReportCardController.prototype.pageChanged = function () {
        var _this = this;
        var data = { id: this.user.id, page: this.currentPage };
        this.UsersModel.getStudentReportcards(data).then(function (response) {
            _this.reportcard = response.reportcards.data[0];
        });
    };
    return StudentReportCardController;
}());
StudentReportCardController.$inject = [
    "UsersModel",
    "user",
    "reportData",
    "VueStoreFactory",
];
exports.default = StudentReportCardController;
